module.exports = __webpack_public_path__ + "static/media/ML Building Damage Assesment.42461a3f.mp4";